/** Genel site/marka ayarları — tüm uygulamaya (ve login ekranına) yansır. */
export interface Branding {
  appName: string;
  siteTitle: string;
  logo: string; // data-URL veya boş
  font: string; // FONT_OPTIONS anahtarı
  domain: string; // uygulamanın yayınlanacağı alan adı (ör. tahsilat.persas.com.tr)
}

export const DEFAULT_BRANDING: Branding = {
  appName: 'Persas Tahsilat',
  siteTitle: 'Persas Tahsilat',
  logo: '',
  font: 'system',
  domain: '',
};

export interface FontOption {
  key: string;
  label: string;
  /** CSS font-family yığını (--sans jetonuna yazılır). */
  stack: string;
  /** Sistem-dışı fontlar için Google Fonts family parametresi. */
  google?: string;
}

const SYSTEM_STACK =
  'ui-sans-serif, system-ui, -apple-system, "Segoe UI", Roboto, Helvetica, Arial, "Apple Color Emoji"';

export const FONT_OPTIONS: FontOption[] = [
  { key: 'system', label: 'Sistem (varsayılan)', stack: SYSTEM_STACK },
  { key: 'inter', label: 'Inter', stack: `"Inter", ${SYSTEM_STACK}`, google: 'Inter:wght@400;500;600;700' },
  { key: 'roboto', label: 'Roboto', stack: `"Roboto", ${SYSTEM_STACK}`, google: 'Roboto:wght@400;500;700' },
  { key: 'poppins', label: 'Poppins', stack: `"Poppins", ${SYSTEM_STACK}`, google: 'Poppins:wght@400;500;600;700' },
  { key: 'nunito', label: 'Nunito', stack: `"Nunito", ${SYSTEM_STACK}`, google: 'Nunito:wght@400;600;700;800' },
  { key: 'montserrat', label: 'Montserrat', stack: `"Montserrat", ${SYSTEM_STACK}`, google: 'Montserrat:wght@400;500;600;700' },
  { key: 'mulish', label: 'Mulish', stack: `"Mulish", ${SYSTEM_STACK}`, google: 'Mulish:wght@400;500;600;700' },
];

export function resolveFont(key: string): FontOption {
  return FONT_OPTIONS.find((o) => o.key === key) ?? FONT_OPTIONS[0];
}
